{
  "title": "Remove Volunteer",
  "confirm": "Remove {{person}} from the {{team}} team?",
  "confirmUnnamed": "Remove this volunteer from this team?",
  "caption": "This doesn't delete them from your church's People. You can invite them back to this team at any time.",
  "remove": "Remove from Team",
  "removing": "Removing..."
}
